import React from 'react';
import './Footer.css';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-brand">AIEx</h3>
            <p className="footer-description">
              Empowering companies with intelligent knowledge access through AI-powered chatbots.
            </p>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">Product</h4>
            <ul className="footer-links">
              <li><a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>Features</a></li>
              <li><a href="#benefits" onClick={(e) => { e.preventDefault(); scrollToSection('benefits'); }}>Benefits</a></li>
              <li><a href="#cta" onClick={(e) => { e.preventDefault(); scrollToSection('cta'); }}>Get Started</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">Company</h4>
            <ul className="footer-links">
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About Us</a></li>
              <li><a href="#cta" onClick={(e) => { e.preventDefault(); scrollToSection('cta'); }}>Contact</a></li>
              <li><a href="#cta" onClick={(e) => { e.preventDefault(); scrollToSection('cta'); }}>Careers</a></li>
              <li><a href="#cta" onClick={(e) => { e.preventDefault(); scrollToSection('cta'); }}>Blog</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">Resources</h4>
            <ul className="footer-links">
              <li><a href="#cta" onClick={(e) => { e.preventDefault(); scrollToSection('cta'); }}>Documentation</a></li>
              <li><a href="#cta" onClick={(e) => { e.preventDefault(); scrollToSection('cta'); }}>Support</a></li>
              <li><a href="#cta" onClick={(e) => { e.preventDefault(); scrollToSection('cta'); }}>Privacy Policy</a></li>
              <li><a href="#cta" onClick={(e) => { e.preventDefault(); scrollToSection('cta'); }}>Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} AIEx Partners. All rights reserved.</p>
          <div className="footer-social">
            <a href="#" aria-label="LinkedIn">LinkedIn</a>
            <a href="#" aria-label="Twitter">Twitter</a>
            <a href="#" aria-label="GitHub">GitHub</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

